<template>
	<div class="steps__step-form">
		<h3 class="h4 h4--b">
			List all known designers, developers, and partners
		</h3>
		<p class="mb-24">
			All fields listed below are <b>optional</b>.
		</p>
		<form
			class="form form--fixed-fields"
			@submit.prevent="updateForm"
		>
			<fieldset>
				<legend class="h5 h5--b">
					Design team &amp; developer
				</legend>
				<InputComponent
					:value="form_fields.architect"
					type="checkboxes-dropdown"
					input-id="architect"
					name="architect"
					label="Architect"
					placeholder="Search"
					:options="filtered_architects"
					:selection-label="selected_architects_label"
					filter-key="architect"
					:filter-search="form_fields.architect.search_query"
					:active-values="form_fields.architect.values"
					:required="false"
					:errors="form_errors.architect || null"
					@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'architect' )"
				/>
				<NewCompanyFormComponent
					field-handle="architect"
					form-title="Architect"
					@refresh:companies="( value, handle ) => updateCompanies( value, handle )"
				/>
				<InputComponent
					:value="form_fields.landscape_architect"
					type="checkboxes-dropdown"
					input-id="landscape-architect"
					name="landscape-architect"
					label="Landscape Architect"
					placeholder="Search"
					:options="filtered_landscape_architects"
					:selection-label="selected_landscape_architects_label"
					filter-key="landscape_architect"
					:filter-search="form_fields.landscape_architect.search_query"
					:active-values="form_fields.landscape_architect.values"
					:required="false"
					:errors="form_errors.landscape_architect || null"
					@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'landscape_architect' )"
				/>
				<NewCompanyFormComponent
					field-handle="landscape_architect"
					form-title="Landscape Architect"
					@refresh:companies="( value, handle ) => updateCompanies( value, handle )"
				/>
				<InputComponent
					:value="form_fields.interior_design"
					type="checkboxes-dropdown"
					input-id="interior-designer"
					name="interior-designer"
					label="Interior Designer"
					placeholder="Search"
					:options="filtered_interior_designers"
					:selection-label="selected_interior_designers_label"
					filter-key="interior_design"
					:filter-search="form_fields.interior_design.search_query"
					:active-values="form_fields.interior_design.values"
					:required="false"
					:errors="form_errors.interior_design || null"
					@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'interior_design' )"
				/>
				<NewCompanyFormComponent
					field-handle="interior_design"
					form-title="Interior Designer"
					@refresh:companies="( value, handle ) => updateCompanies( value, handle )"
				/>
				<InputComponent
					:value="form_fields.developer"
					type="checkboxes-dropdown"
					input-id="developer"
					name="developer"
					label="Developer"
					placeholder="Search"
					:options="filtered_developers"
					:selection-label="selected_developers_label"
					filter-key="developer"
					:filter-search="form_fields.developer.search_query"
					:active-values="form_fields.developer.values"
					:required="false"
					:errors="form_errors.developer || null"
					@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'developer' )"
				/>
				<NewCompanyFormComponent
					field-handle="developer"
					form-title="Developer"
					@refresh:companies="( value, handle ) => updateCompanies( value, handle )"
				/>
			</fieldset>
			<fieldset>
				<legend class="h5 h5--b">
					Partners
				</legend>
				<InputComponent
					:value="form_fields.creative_agency"
					type="checkboxes-dropdown"
					input-id="creative-agency"
					name="creative-agency"
					label="Creative Agency"
					placeholder="Search"
					:options="filtered_creative_agencies"
					:selection-label="selected_creative_agencies_label"
					filter-key="creative_agency"
					:filter-search="form_fields.creative_agency.search_query"
					:active-values="form_fields.creative_agency.values"
					:required="false"
					:errors="form_errors.creative_agency || null"
					@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'creative_agency' )"
				/>
				<NewCompanyFormComponent
					field-handle="creative_agency"
					form-title="Creative Agency"
					@refresh:companies="( value, handle ) => updateCompanies( value, handle )"
				/>
				<InputComponent
					:value="form_fields.brand_partner"
					type="checkboxes-dropdown"
					input-id="brand-partner"
					name="brand-partner"
					label="Brand Partner"
					placeholder="Search"
					:options="filtered_brand_partners"
					:selection-label="selected_brand_partners_label"
					filter-key="brand_partner"
					:filter-search="form_fields.brand_partner.search_query"
					:active-values="form_fields.brand_partner.values"
					:required="false"
					:errors="form_errors.brand_partner || null"
					@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'brand_partner' )"
				/>
				<NewCompanyFormComponent
					field-handle="brand_partner"
					form-title="Brand Partner"
					@refresh:companies="( value, handle ) => updateCompanies( value, handle )"
				/>
				<InputComponent
					:value="form_fields.sales_marketing"
					type="checkboxes-dropdown"
					input-id="sales-marketing"
					name="sales-marketing"
					label="Sales & Marketing Partner"
					placeholder="Search"
					:options="filtered_sales_marketing"
					:selection-label="selected_sales_marketing_label"
					filter-key="sales_marketing"
					:filter-search="form_fields.sales_marketing.search_query"
					:active-values="form_fields.sales_marketing.values"
					:required="false"
					:errors="form_errors.sales_marketing || null"
					@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'sales_marketing' )"
				/>
				<NewCompanyFormComponent
					field-handle="sales_marketing"
					form-title="Sales & Marketing Partner"
					@refresh:companies="( value, handle ) => updateCompanies( value, handle )"
				/>
				<InputComponent
					:value="form_fields.hospitality_operator"
					type="checkboxes-dropdown"
					input-id="hospitality-operator"
					name="hospitality-operator"
					label="Hospitality Operator"
					placeholder="Search"
					:options="filtered_hospitality_operators"
					:selection-label="selected_hospitality_operators_label"
					filter-key="hospitality_operator"
					:filter-search="form_fields.hospitality_operator.search_query"
					:active-values="form_fields.hospitality_operator.values"
					:required="false"
					:errors="form_errors.hospitality_operator || null"
					@update:value="( value ) => handleCheckboxDropdownUpdate( value, 'hospitality_operator' )"
				/>
				<NewCompanyFormComponent
					field-handle="hospitality_operator"
					form-title="Hospitality Operator"
					@refresh:companies="( value, handle ) => updateCompanies( value, handle )"
				/>
			</fieldset>
			<button
				class="button button--fill"
				type="submit"
			>
				Save {{ stepTitle }}
			</button>
		</form>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { ref, computed, defineProps, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import InputComponent from '../InputComponent';
import NewCompanyFormComponent from './NewCompanyFormComponent';

const new_project_store = useNewProjectStore();
const { getCompanies, validateNewProjectStep, setCheckboxDropdownValue, removeCheckboxDropdownValue } = new_project_store;
const {
	form_fields,
	form_errors,
	filtered_architects,
	selected_architects,
	filtered_landscape_architects,
	selected_landscape_architects,
	filtered_interior_designers,
	selected_interior_designers,
	filtered_developers,
	selected_developers,
	filtered_creative_agencies,
	selected_creative_agencies,
	filtered_brand_partners,
	selected_brand_partners,
	filtered_sales_marketing,
	selected_sales_marketing_partners,
	filtered_hospitality_operators,
	selected_hospitality_operators
} = storeToRefs( new_project_store );

defineProps( {
	stepTitle: {
		required: true,
		type: String,
		default: ''
	}
} );

const loading = ref( true );

onMounted ( async() => {
	await getCompanies();

	loading.value = false;
} );

async function updateForm() {
	validateNewProjectStep();
}

const handleCheckboxDropdownUpdate = ( object, handle ) => { // eslint-disable-line snakecasejs/snakecasejs
	if ( object.checked ) {
		setCheckboxDropdownValue( object.value, handle );
	} else {
		removeCheckboxDropdownValue( object.value, handle );
	}
};

async function updateCompanies( title, handle ) {
	await getCompanies();
	if ( !title ) {
		return;
	}
	let item = {};
	switch ( handle ) {
		case 'architect':
			item = filtered_architects.value.find( ( { label } ) => label === title );
			break;
		case 'landscape_architect':
			item = filtered_landscape_architects.value.find( ( { label } ) => label === title );
			break;
		case 'interior_design':
			item = filtered_interior_designers.value.find( ( { label } ) => label === title );
			break;
		case 'developer':
			item = filtered_developers.value.find( ( { label } ) => label === title );
			break;
		case 'creative_agency':
			item = filtered_creative_agencies.value.find( ( { label } ) => label === title );
			break;
		case 'brand_partner':
			item = filtered_brand_partners.value.find( ( { label } ) => label === title );
			break;
		case 'sales_marketing':
			item = filtered_sales_marketing.value.find( ( { label } ) => label === title );
			break;
		case 'hospitality_operator':
			item = filtered_hospitality_operators.value.find( ( { label } ) => label === title );
			break;
		default:
			return;
	}
	if ( !item || !item.value ) {
		return;
	}
	setCheckboxDropdownValue( item.value, handle );
}

const selected_architects_label = computed( () => {
	return selected_architects.value
		.map( item => item.label )
		.join( ', ' )
	;
} );
const selected_landscape_architects_label = computed( () => {
	return selected_landscape_architects.value
		.map( item => item.label )
		.join( ', ' )
	;
} );
const selected_interior_designers_label = computed( () => {
	return selected_interior_designers.value
		.map( item => item.label )
		.join( ', ' )
	;
} );
const selected_developers_label = computed( () => {
	return selected_developers.value
		.map( item => item.label )
		.join( ', ' )
	;
} );
const selected_creative_agencies_label = computed( () => {
	return selected_creative_agencies.value
		.map( item => item.label )
		.join( ', ' )
	;
} );
const selected_brand_partners_label = computed( () => {
	return selected_brand_partners.value
		.map( item => item.label )
		.join( ', ' )
	;
} );
const selected_sales_marketing_label = computed( () => {
	return selected_sales_marketing_partners.value
		.map( item => item.label )
		.join( ', ' )
	;
} );
const selected_hospitality_operators_label = computed( () => {
	return selected_hospitality_operators.value
		.map( item => item.label )
		.join( ', ' )
	;
} );

</script>
